/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_SentInputs */

const en_friends_sent = /** @type {(inputs: Friends_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent.`)
};

const de_friends_sent = /** @type {(inputs: Friends_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendet.`)
};

/**
* | output |
* | --- |
* | "Sent." |
*
* @param {Friends_SentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_sent = /** @type {((inputs?: Friends_SentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_SentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_sent(inputs)
	return en_friends_sent(inputs)
});